export { default } from './EzOnOff.vue';
